module.exports = __webpack_public_path__ + "static/media/Raven545_1c.fc62b8a3.svg";